module.exports = __webpack_public_path__ + "img/removeresume.6b45cbc1.svg";